/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { OverridableComponent, OverrideProps } from '@coursera/cds-common';
import { Link } from '@coursera/cds-core';
import type { LinkProps } from '@coursera/cds-core';

type BaseProps = Partial<LinkProps> & {
  children: React.ReactNode;
};

interface LinkTagTypeMap<D extends React.ElementType = 'a'> {
  props: BaseProps;
  defaultComponent: D;
}
type Props<D extends React.ElementType = LinkTagTypeMap['defaultComponent']> = OverrideProps<LinkTagTypeMap<D>, D> & {
  component?: React.ElementType;
};

const styles = {
  skillsLinkTag: css({
    display: 'inline-flex',
    alignItems: 'center',
    border: '1px solid',
    borderRadius: '4px',
    padding: '0 var(--cds-spacing-100)',
    backgroundColor: 'var(--cds-color-neutral-disabled)',
    borderColor: 'var(--cds-color-neutral-disabled)',
    boxShadow: 'none',
  }),
  skillsLink: css({
    color: 'var(--cds-color-neutral-primary)',
    ':visited:not(.cds-link-focusVisible), :visited, :hover': {
      color: 'var(--cds-color-neutral-primary)',
    },
  }),
};

export const LinkTag: OverridableComponent<LinkTagTypeMap> = ({ children, ...linkProps }: Props) => {
  return (
    <span css={styles.skillsLinkTag}>
      <Link variant="quiet" typographyVariant="bodySecondary" css={styles.skillsLink} {...linkProps}>
        {children}
      </Link>
    </span>
  );
};

export default LinkTag;
